// NOTE: RUN-2927 — trois formes de checkpoint coexistent, parce que les
// documents PouchDB survivent aux mises à jour de l'app :
//   - legacy `tmp-checkpoints` (< v2.34.1) : { category_id: 11880 }
//   - relation devour (incluse ou simple linkage) : { category: { id: '11880' } }
//   - relation absente : audit persisté par 2.34.1 / 2.34.2
export const getCheckpointCategoryId = (checkpoint) => {
  if (!checkpoint) return null
  const raw =
    checkpoint.category && checkpoint.category.id !== undefined
      ? checkpoint.category.id
      : checkpoint['category_id']
  const id = Number(raw)
  return Number.isFinite(id) && id > 0 ? id : null
}

// NOTE: forme canonique persistée en local — ids numériques et `category`
// réduite à { id }, le `type` renvoyé par devour n'ayant aucune valeur métier.
// `category_id` est conservé s'il existait : un doc mixte reste lisible.
export const normalizeCheckpoint = (checkpoint) => {
  const categoryId = getCheckpointCategoryId(checkpoint)
  return {
    ...checkpoint,
    id: Number(checkpoint.id),
    category: categoryId ? { id: categoryId } : null
  }
}

export const normalizeCheckpoints = (checkpoints) =>
  Array.isArray(checkpoints) ? checkpoints.map(normalizeCheckpoint) : []

// NOTE: FEAT-4256 — depuis la migration tmp-checkpoints -> checklist.checkpoints
// (723bff4b, v2.34.1), les checkpoints viennent du template complet de la
// checklist, qui n'a aucun contexte d'audit : le serveur ne peut plus filtrer
// les exclusions. Le croisement avec `audit['excluded-checkpoints']` est donc à
// notre charge. Les ids d'exclusion arrivent en string, les checkpoints
// normalisés portent un id numérique : on compare en Number des deux côtés.
export const rejectExcludedCheckpoints = (checkpoints, excludedIds) => {
  const excluded = new Set(
    (Array.isArray(excludedIds) ? excludedIds : [])
      .map(Number)
      .filter((id) => Number.isFinite(id))
  )
  return normalizeCheckpoints(checkpoints).filter((cp) => !excluded.has(cp.id))
}

// NOTE: FEAT-4256 — findOrCreateReport ne projette les checkpoints de l'audit
// dans le brouillon qu'à la création : un contrôle commencé avant le correctif
// garde sa liste non filtrée, et reste inarchivable (reportComplete exige une
// réponse sur chaque checkpoint). On retire le checkpoint exclu ainsi que
// l'anomalie saisie dessus — la laisser produirait une anomalie orpheline dans
// le rapport envoyé. Retourne null quand il n'y a rien à retirer, pour éviter
// une écriture PouchDB inutile.
export const pruneDraftCheckpoints = (report, allowedIds) => {
  if (!report || !Array.isArray(report.checkpoints)) return null
  const allowed = new Set(
    (Array.isArray(allowedIds) ? allowedIds : []).map(Number)
  )
  const checkpoints = report.checkpoints.filter((cp) =>
    allowed.has(Number(cp.id))
  )
  if (checkpoints.length === report.checkpoints.length) return null
  const issues = Array.isArray(report.issues)
    ? report.issues.filter((issue) =>
        allowed.has(Number(issue.checkpoint && issue.checkpoint.id))
      )
    : report.issues
  return { ...report, checkpoints, issues }
}
